(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-addon-guard"] && !Shopify.designMode) return;
  try {
    // cart-addon-guard — clamp add-on qty to 1; remove orphaned add-ons.
  (function () {
    if (window.__sbCartGuard) return;
    window.__sbCartGuard = true;

    var ADDON_SKUS = ['EXSHIP', 'INSTRUMENTALSONG', 'SOUNDBOX-ADDON', 'PLAQUE-ADDON']; /* ADR-085: keepsake add-ons ride on a song too */
    var busy = false;

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function swap(destSelector, html, srcSelector) {
      if (!html) return;
      var dest = document.querySelector(destSelector);
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(srcSelector);
      if (dest && src) dest.innerHTML = src.innerHTML;
    }

    function showNote(text) {
      var host = document.querySelector('cart-drawer .drawer__contents') || document.querySelector('#main-cart-items .js-contents');
      if (!host || host.querySelector('.cart-guard-note')) return;
      var p = document.createElement('p');
      p.className = 'cart-guard-note';
      p.setAttribute('role', 'status');
      p.textContent = text;
      host.insertBefore(p, host.firstChild);
    }

    function rerender(res, orphaned) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(res);
      } else if (res.sections) {
        swap('#main-cart-items .js-contents', res.sections['main-cart-items'], '.js-contents');
        swap('#main-cart-footer .js-contents', res.sections['main-cart-footer'], '.js-contents');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections['cart-icon-bubble']) {
          var nb = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (nb) bubble.innerHTML = nb.innerHTML;
        }
      }
      if (orphaned) showNote('Add-ons removed — they apply to a song in your cart.');
    }

    function run() {
      if (busy) return;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var hasParent = cart.items.some(function (i) { return ADDON_SKUS.indexOf(i.sku) === -1; });
          var updates = {};
          var changed = false;
          var orphaned = false;
          cart.items.forEach(function (i) {
            if (ADDON_SKUS.indexOf(i.sku) === -1) return;
            var want = hasParent ? Math.min(i.quantity, 1) : 0;
            if (want !== i.quantity) {
              updates[i.variant_id] = want;
              changed = true;
              if (want === 0) orphaned = true;
            }
          });
          if (!changed) return;

          var drawer = document.querySelector('cart-drawer');
          var sections;
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          } else {
            sections = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
          }

          busy = true;
          return fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname }),
          })
            .then(function (r) { return r.json(); })
            .then(function (res) { if (res && !res.status) rerender(res, orphaned); })
            .catch(function () {})
            .then(function () { busy = false; });
        })
        .catch(function () {});
    }

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);

    // Dawn publishes cart updates through its pubsub — react to song removals etc.
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(run, 50); });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-addon-upsell"] && !Shopify.designMode) return;
  try {
    // cart-addon-upsell — add an add-on without leaving the cart, then refresh in place.
  (function () {
    if (window.__sbCartUpsell) return;
    window.__sbCartUpsell = true;

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function swap(destSelector, html, srcSelector) {
      if (!html) return;
      var dest = document.querySelector(destSelector);
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(srcSelector);
      if (dest && src) dest.innerHTML = src.innerHTML;
    }

    function addAddon(id, btn) {
      var drawer = document.querySelector('cart-drawer');
      var onPage = document.getElementById('main-cart-items');
      var sections;
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      } else {
        sections = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
      }

      var body = {
        items: [{ id: id, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      };

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.status) return; // 422 etc.
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res);
          } else if (onPage && res.sections) {
            swap('#main-cart-items .js-contents', res.sections['main-cart-items'], '.js-contents');
            swap('#main-cart-footer .js-contents', res.sections['main-cart-footer'], '.js-contents');
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && res.sections['cart-icon-bubble']) {
              var newBubble = new DOMParser()
                .parseFromString(res.sections['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section');
              if (newBubble) bubble.innerHTML = newBubble.innerHTML;
            }
          }
        })
        .catch(function () {})
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.cart-upsell__add') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      addAddon(id, btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sb-product-landing"] && !Shopify.designMode) return;
  try {
    (function(){
  'use strict';
  function init(){
    document.querySelectorAll('.sb-product-landing').forEach(function(root){
      if(root.dataset.wired==='true')return;
      root.dataset.wired='true';
      var rail=root.querySelector('[data-sb-video-rail]');
      var previous=root.querySelector('[data-sb-video-prev]'),next=root.querySelector('[data-sb-video-next]');
      if(rail){
        function syncRail(){previous.disabled=rail.scrollLeft<=2;next.disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2;}
        function move(direction){var card=rail.firstElementChild;if(!card)return;var gap=parseFloat(getComputedStyle(rail).columnGap)||0;rail.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
        previous.addEventListener('click',function(){move(-1);});next.addEventListener('click',function(){move(1);});
        rail.addEventListener('scroll',syncRail,{passive:true});
        rail.addEventListener('keydown',function(event){if(event.target!==rail)return;if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}});
        if('ResizeObserver' in window)new ResizeObserver(syncRail).observe(rail);
        syncRail();
      }
      root.querySelectorAll('[data-sb-sample-play]').forEach(function(button){
        var card=button.closest('[data-sb-sample-card]');
        var audio=card&&card.querySelector('[data-sb-sample-audio]');
        if(!audio)return;
        function sync(){
          var playing=!audio.paused&&!audio.ended;
          button.setAttribute('aria-pressed',String(playing));
          button.setAttribute('aria-label',playing?button.dataset.pauseLabel:button.dataset.playLabel);
        }
        button.addEventListener('click',function(){
          if(!audio.paused){audio.pause();return;}
          if(!audio.src&&audio.dataset.src)audio.src=audio.dataset.src;
          var attempt=audio.play();
          if(attempt)attempt.catch(function(){sync();audio.controls=true;audio.hidden=false;});
        });
        ['play','pause','ended','error'].forEach(function(event){audio.addEventListener(event,sync);});
      });
      root.querySelectorAll('[data-sb-video-play]').forEach(function(button){
        button.addEventListener('click',function(){
          var card=button.closest('[data-sb-video-card]');
          var video=card&&card.querySelector('video');
          if(!video)return;
          if(!video.src&&video.dataset.src)video.src=video.dataset.src;
          video.hidden=false;video.controls=true;
          var poster=card.querySelector('[data-sb-video-poster]');
          var started=video.play();
          if(started)started.then(function(){button.hidden=true;if(poster)poster.hidden=true;}).catch(function(){button.hidden=false;});
        });
      });
      root.querySelectorAll('video,audio').forEach(function(media){
        media.addEventListener('play',function(){document.querySelectorAll('video,audio').forEach(function(other){if(other!==media)other.pause();});});
      });
      if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(!entry.isIntersecting)entry.target.querySelectorAll('video,audio').forEach(function(media){media.pause();});});},{threshold:.05});root.querySelectorAll('[data-sb-video-card],[data-sb-sample-card]').forEach(function(card){observer.observe(card);});}
      document.addEventListener('visibilitychange',function(){if(document.hidden)root.querySelectorAll('video,audio').forEach(function(media){media.pause();});});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["song-brief"] && !Shopify.designMode) return;
  try {
    // song-brief — one behavior for every .sb-brief on the page. Idempotent.
  // Adaptive prompts + context pre-fill + voice (attach/record); exposes an API
  // (validate/collect/getVoice) on each [data-song-brief] root for the host's
  // add-to-cart. No pricing or cart logic lives here.
  (function () {
    if (window.__sbBriefInit) return;
    window.__sbBriefInit = true;

    var REL = {
      partner:{memory:"the night we met at Dani’s party",like:"goofy, kind, always cold",detail:"our spot — the corner booth at Joe’s",mean:"my person, my calm"},
      spouse:{memory:"our first dance at the lake house",like:"stubborn, generous, terrible at cards",detail:"we say ‘see ya, see ya bye’",mean:"25 years — still my best friend"},
      parent:{memory:"Sunday pancakes, her humming in the kitchen",like:"fierce, funny, never sits still",detail:"always says ‘OMG’",mean:"she raised me twice"},
      child:{memory:"the day she was born — tiny and loud",like:"curious, brave, obsessed with dinosaurs",detail:"we call him Bug",mean:"my whole heart"},
      friend:{memory:"that road trip we still laugh about",like:"loyal, blunt, the planner",detail:"inside joke: ‘the goose incident’",mean:"my ride-or-die for 15 years"},
      pet:{memory:"the day we brought her home from the shelter",like:"steals socks, naps in sunbeams",detail:"we call her Bean",mean:"got me through a hard year"},
      memorial:{memory:"long porch talks, his old guitar",like:"gentle, stubborn, always singing",detail:"signed every note ‘love, Pop’",mean:"the man who taught me everything"},
      other:{memory:"a moment that says who they are",like:"their quirks — what they always do",detail:"a nickname or inside joke",mean:"why they matter to you"}
    };
    var QMAP = {
      spouse:["How did you two meet?","What do you love most about them?","An inside joke or detail only you two share","What they mean to you — and why now"],
      partner:["How did you two meet?","What do you love most about them?","An inside joke or detail only you two share","What they mean to you — and why now"],
      parent:["A memory that says who they are","What did they always say or do?","Something they taught you, or a family saying","What they mean to you — and why now"],
      child:["A moment with them you’ll never forget","What are they like? (their quirks)","A nickname, or something only your family knows","Your hopes for them — and why this song now"],
      friend:["How did you become friends?","What makes them a great friend?","An inside joke or a story you both retell","What their friendship means to you"],
      pet:["How did they come into your life?","What are they like? (their funny habits)","What you call them, or a quirk only you’d know","What they mean to you — and why now"],
      memorial:["A memory that captures who they were","What were they like?","Something they always said or did","What they meant to you — and what you miss most"],
      other:["A favorite memory with them","What are they like?","A nickname, inside joke, or detail only you’d know","What they mean to you — and why now"]
    };
    // occasion → optional milestone field + a sensible default relationship
    var OCC = {
      anniversary:{rel:"spouse", ms:{label:"Which anniversary?", type:"select", opts:["Choose…","1st (paper)","5th (wood)","10th (tin)","25th (silver)","40th (ruby)","50th (gold)","Another year"]}},
      birthday:{rel:"friend"},
      wedding:{rel:"spouse", ms:{label:"Wedding date", type:"date"}},
      retirement:{rel:"parent", ms:{label:"Years of service (or what they’re retiring from)", type:"text", ph:"e.g., 30 years at the fire dept"}},
      graduation:{rel:"child", ms:{label:"What are they graduating from?", type:"text", ph:"e.g., high school, nursing school"}},
      "valentine's day":{rel:"partner"}, "mother's day":{rel:"parent"}, "father's day":{rel:"parent"},
      memorial:{rel:"memorial"}, christmas:{rel:"friend"}, "thank you":{rel:"friend"},
      "just because":{rel:"partner"}, other:{rel:"other"}
    };
    // mood follows the relationship (overridable by the visitor)
    var MOOD = { spouse:"romantic", partner:"romantic", parent:"nostalgic", child:"happy", friend:"upbeat", pet:"happy", memorial:"emotional", other:"emotional" };

    // Angle-PDP intent sets — recipient label + 4 story prompts (+ placeholders) +
    // optional story-section subtitle. Selected per product via data-form-intent (a
    // product metafield custom.form_intent). data-form-prompts (metafield
    // custom.form_prompts, newline-separated) can override the prompt LABELS free-form.
    // When neither attribute is present the relationship-adaptive defaults above run
    // unchanged, so every non-angle page (custom-song, occasion modals, plaque) is
    // untouched. Pride angles keep using pride MODE (data-pride), not an intent set.
    var FORM_INTENTS = {
      "drive-safe":{
        recipient:"Who's heading out the door?",
        sub:"Tell us about them and the goodbye you always say — we'll build the song around it.",
        prompts:["Who are they to you, and where are they driving off to?","What do you always say before they leave?","A memory from the driveway, the porch, the goodbye","What you want them to feel every time it plays"],
        phs:["my granddaughter, leaving for college in Ohio","text me when you get home","she still beeps twice pulling out of the drive","that home is always right behind them"],
        hide:["occasion","mood"], occasion:"Drive Safe", mood:"nostalgic"
      },
      "memorial":{
        recipient:"Who are we remembering?",
        sub:"Tell us about them — a few words for each is enough, or leave a voice note.",
        prompts:["A memory that captures who they were","What were they like?","Something they always said or did","What they meant to you — and what you miss most"],
        phs:["long porch talks, his old guitar","gentle, stubborn, always singing","signed every note 'love, Pop'","the man who taught me everything"]
      },
      "kids-birthday":{
        recipient:"Whose birthday is it?",
        sub:"Tell us about the birthday kid — a few words for each is enough.",
        prompts:["How old are they turning, and what are they into right now?","A moment with them you'll never forget","What are they like? (their quirks)","What you want them to feel on their day"],
        phs:["turning 7, obsessed with dinosaurs","the day she learned to ride her bike","fearless, silly, terrible at hiding","how loved they are"],
        hide:["occasion","mood"], occasion:"Birthday", mood:"happy"
      },
      "apology":{
        recipient:"Who are you apologizing to?",
        sub:"Tell us who you hurt and what you wish you'd said — a few words for each is enough, or leave a voice note.",
        prompts:["Who are you saying sorry to, and what are they to you?","What happened — what are you sorry for?","What do they mean to you, in your words?","How do you want to make it right?"],
        phs:["my wife Sarah — my best friend of 20 years","I put work first and kept letting her down","she's the calm in every storm I've caused","show her I've changed, not just say it"],
        hide:["occasion","mood"], occasion:"Apology", mood:"emotional"
      }
    };

    function val(el) { return el ? (el.value || '').trim() : ''; }
    function urlp(k) { try { return new URLSearchParams(window.location.search).get(k) || ''; } catch (e) { return ''; } }
    function setSel(sel, v) { if (!sel || !v) return false; v = String(v).toLowerCase(); for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value.toLowerCase() === v) { sel.selectedIndex = i; return true; } } return false; }

    function wire(root) {
      if (root.__sbWired) return;
      root.__sbWired = true;

      var rel = root.querySelector('[data-rel]');
      var occ = root.querySelector('[data-occ]');
      var msWrap = root.querySelector('[data-milestone-wrap]');
      var msLabel = root.querySelector('[data-milestone-label]');
      var msControl = root.querySelector('[data-milestone-control]');
      var moodSel = root.querySelector('[data-k="Song Mood"]');
      var userSetMood = false;
      setSel(rel, (root.getAttribute('data-ctx-rel') || '') || urlp('relationship') || urlp('rel'));
      setSel(occ, (root.getAttribute('data-ctx-occ') || '') || urlp('occasion') || urlp('occ'));

      // Angle-PDP intent: a named set (data-form-intent) and/or a free-form prompt
      // override (data-form-prompts, "|"-separated). Both absent → customPrompts is
      // null and applyRel behaves exactly as before.
      var intentKey = (root.getAttribute('data-form-intent') || '').toLowerCase();
      var intent = FORM_INTENTS[intentKey] || null;
      var promptsAttr = root.getAttribute('data-form-prompts') || '';
      var customPrompts = promptsAttr ? promptsAttr.split('|') : (intent ? intent.prompts : null);
      var intentPhs = intent ? intent.phs : null;
      if (intent) {
        var recIn = root.querySelector('[data-k="Recipient Name"]');
        var recLabel = recIn ? root.querySelector('label[for="' + recIn.id + '"]') : null;
        if (recLabel && intent.recipient) recLabel.innerHTML = intent.recipient + '<span class="sb-brief__req" aria-hidden="true">*</span>';
        var subEl = root.querySelector('.sb-brief__cardsub');
        if (subEl && intent.sub) subEl.textContent = intent.sub;
      }

      // Per-intent field visibility. data-form-hide (metafield custom.form_hide,
      // comma-separated) overrides the intent's hide list. Hidden fields still
      // submit sensible defaults so fulfillment loses no data. Absent → nothing
      // hidden → today's full field set.
      var hideAttr = (root.getAttribute('data-form-hide') || '').toLowerCase();
      var hideSet = hideAttr ? hideAttr.split(',') : (intent && intent.hide ? intent.hide : null);
      if (hideSet) {
        var hideWrap = function (el, sel) {
          var w = el && el.closest(sel || '.sb-brief__field'); if (!w) return; w.style.display = 'none';
          var row = w.closest('.sb-brief__two');
          if (row) { var shown = 0; row.querySelectorAll('.sb-brief__field').forEach(function (f) { if (f.style.display !== 'none') shown++; }); if (shown <= 1) row.style.gridTemplateColumns = '1fr'; }
        };
        hideSet.forEach(function (raw) {
          var key = (raw || '').trim();
          if (key === 'occasion') {
            hideWrap(occ);
            if (msWrap) msWrap.hidden = true;
            var occVal = (intent && intent.occasion) || (root.getAttribute('data-ctx-occ') || '');
            if (occ) occ.removeAttribute('data-k');
            if (occVal) { var oi = document.createElement('input'); oi.type = 'hidden'; oi.setAttribute('data-k', 'Occasion'); oi.value = occVal; root.appendChild(oi); }
          } else if (key === 'milestone') {
            if (msWrap) msWrap.hidden = true;
          } else if (key === 'mood') {
            hideWrap(moodSel);
            if (moodSel && intent && intent.mood) setSel(moodSel, intent.mood);
            userSetMood = true;
          } else if (key === 'relationship') {
            hideWrap(rel);
          } else if (key === 'style') {
            hideWrap(root.querySelector('[data-k="Music Style"]'));
          } else if (key === 'voice') {
            hideWrap(root.querySelector('[data-k="Singer Preference"]'));
          } else if (key === 'mentions') {
            hideWrap(root.querySelector('[data-k="Special Mentions"]'), '.sb-brief__prompt');
          } else if (key === 'voicenote') {
            var vn = root.querySelector('[data-voice]'); if (vn) vn.style.display = 'none';
          }
        });
      }

      function applyRel() {
        var r = rel ? rel.value : 'other', qs = customPrompts || QMAP[r] || QMAP.other;
        root.querySelectorAll('.sb-brief__pl[data-q]').forEach(function (l) { var s = parseInt(l.getAttribute('data-q'), 10); if (qs[s]) l.textContent = qs[s]; });
        if (customPrompts) {
          root.querySelectorAll('.sb-brief__pin[data-slot]').forEach(function (i) { var s = parseInt(i.getAttribute('data-slot'), 10); i.setAttribute('placeholder', (intentPhs && intentPhs[s]) ? intentPhs[s] : ''); });
        } else {
          var ex = REL[r] || REL.other;
          root.querySelectorAll('[data-ex]').forEach(function (i) { var k = i.getAttribute('data-ex'); if (ex[k] !== undefined) i.setAttribute('placeholder', ex[k]); });
        }
        var moodPick = MOOD[r];
        if (occ && (occ.value || '').toLowerCase() === 'memorial') { moodPick = 'emotional'; }
        if (moodSel && !userSetMood && moodPick) { setSel(moodSel, moodPick); }
      }
      var sbbPride = root.getAttribute('data-pride') === '1';

      function buildMilestone() {
        if (!msWrap) return;
        var cfg = OCC[(occ && occ.value ? occ.value : '').toLowerCase()];
        if (!cfg || !cfg.ms) { msWrap.hidden = true; if (msControl) msControl.innerHTML = ''; return; }
        msWrap.hidden = false;
        if (msLabel) msLabel.textContent = cfg.ms.label;
        var fid = (msLabel && msLabel.getAttribute('for')) || (root.id + '-ms');
        var html;
        if (cfg.ms.type === 'select') {
          html = '<select class="sb-brief__sel sb-brief__sel--ms" id="' + fid + '" data-k="Milestone">';
          cfg.ms.opts.forEach(function (o, i) { html += '<option value="' + (i === 0 ? '' : o) + '">' + o + '</option>'; });
          html += '</select>';
        } else if (cfg.ms.type === 'date') {
          html = '<input class="sb-brief__in" id="' + fid + '" type="date" data-k="Milestone">';
        } else {
          html = '<input class="sb-brief__in" id="' + fid + '" type="text" data-k="Milestone" placeholder="' + (cfg.ms.ph || '') + '">';
        }
        if (msControl) msControl.innerHTML = html;
      }

      if (!sbbPride) {
        var userSetRel = false;
        if (rel) { rel.addEventListener('change', function () { userSetRel = true; applyRel(); }); }
        if (moodSel) { moodSel.addEventListener('change', function () { userSetMood = true; }); }
        if (occ) { occ.addEventListener('change', function () {
          buildMilestone();
          if (!userSetRel) { var cfg = OCC[(occ.value || '').toLowerCase()]; if (cfg && cfg.rel) { setSel(rel, cfg.rel); } }
          applyRel();
        }); }
        buildMilestone();
        applyRel();
      }

      // voice: attach + record
      var voiceBlob = null, voiceName = null;
      var vfile = root.querySelector('[data-vfile]'), vstatus = root.querySelector('[data-vstatus]');
      var vbox = root.querySelector('[data-voice]'), vrec = root.querySelector('[data-vrec]');
      function setStatus(txt, cls) { if (!vstatus) return; vstatus.textContent = txt; vstatus.className = 'sb-brief__vstatus' + (cls ? ' ' + cls : ''); }
      if (vfile) vfile.addEventListener('change', function () { if (vfile.files && vfile.files[0]) { voiceBlob = vfile.files[0]; voiceName = vfile.files[0].name; setStatus('✓ Attached: ' + voiceName, 'is-on'); } });
      var canRec = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder);
      if (vrec && canRec) {
        vrec.hidden = false;
        var mr = null, chunks = [], recState = 'idle', secs = 0, timer = null, stream = null;
        var recLabel = root.querySelector('[data-vrec-label]');
        function fmt(s) { return Math.floor(s / 60) + ':' + (s % 60 < 10 ? '0' : '') + (s % 60); }
        vrec.addEventListener('click', function () {
          if (recState === 'idle') {
            navigator.mediaDevices.getUserMedia({ audio: true }).then(function (s) {
              stream = s; chunks = []; mr = new MediaRecorder(s);
              mr.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
              mr.onstop = function () { voiceBlob = new Blob(chunks, { type: (mr.mimeType || 'audio/webm') }); voiceName = 'voice-note.webm'; if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); } setStatus('✓ Voice note recorded · ' + fmt(secs), 'is-on'); };
              mr.start(); recState = 'rec'; secs = 0; vbox.setAttribute('data-state', 'rec'); if (recLabel) recLabel.textContent = 'Stop'; setStatus('● Recording 0:00', 'is-rec');
              timer = setInterval(function () { secs++; setStatus('● Recording ' + fmt(secs), 'is-rec'); }, 1000);
            }).catch(function () { setStatus('Mic unavailable — attach a file instead', ''); });
          } else if (recState === 'rec') {
            recState = 'idle'; if (timer) clearInterval(timer); vbox.setAttribute('data-state', 'idle'); if (recLabel) recLabel.textContent = 'Re-record'; try { mr.stop(); } catch (e) {}
          }
        });
      }

      // API for the host's add-to-cart
      root.sbBrief = {
        validate: function () {
          var name = root.querySelector('[data-k="Recipient Name"]');
          if (!val(name)) { if (name) { try { name.focus(); } catch (e) {} } return 'Please add who the song is for.'; }
          var hasStory = false, firstEmpty = null;
          root.querySelectorAll('[data-slot]').forEach(function (i) { if (val(i)) hasStory = true; else if (!firstEmpty) firstEmpty = i; });
          if (!hasStory && !voiceBlob) { if (firstEmpty) { try { firstEmpty.focus(); } catch (e) {} } return 'Tell us a little of your story, or add a voice note.'; }
          return '';
        },
        collect: function () {
          var props = {};
          root.querySelectorAll('[data-k]').forEach(function (i) { var v = val(i); if (v) props[i.getAttribute('data-k')] = v; });
          var storyParts = [];
          root.querySelectorAll('[data-slot]').forEach(function (i) {
            var v = val(i);
            if (v) { var lbl = root.querySelector('.sb-brief__pl[data-q="' + i.getAttribute('data-slot') + '"]'); storyParts.push((lbl ? lbl.textContent : 'Story') + ': ' + v); }
          });
          if (storyParts.length) props['Story Details'] = storyParts.join('\n');
          return props;
        },
        getVoice: function () { return voiceBlob ? { blob: voiceBlob, name: voiceName || 'voice-note.webm' } : null; }
      };
    }

    function initAll() { document.querySelectorAll('[data-song-brief]').forEach(wire); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    window.sbBriefInit = initAll;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["song-player"] && !Shopify.designMode) return;
  try {
    // song-player — one behavior for every .sb-player on the page.
  // Real <audio> play/pause/seek/keyboard; progress painted by setting --p on the
  // track (its background gradient does the rest). Idempotent: safe to call again
  // (window.sbPlayerInit) for late/AJAX-injected players.
  (function () {
    if (window.__sbPlayerInit) return;
    window.__sbPlayerInit = true;

    function fmt(s) {
      s = Math.max(0, Math.floor(s || 0));
      var m = Math.floor(s / 60), ss = s % 60;
      return m + ':' + (ss < 10 ? '0' : '') + ss;
    }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function wire(root) {
      if (root.__sbWired) return;
      root.__sbWired = true;

      var audio = root.querySelector('.sb-player__audio');
      var btn = root.querySelector('.sb-player__play');
      var track = root.querySelector('.sb-player__track');
      var cur = root.querySelector('.sb-player__cur');
      var dur = root.querySelector('.sb-player__dur');
      if (!audio || !track) return;
      var title = root.getAttribute('data-title') || 'song';

      function paint(p) {
        p = clamp(p, 0, 1);
        track.style.setProperty('--p', (p * 100).toFixed(2) + '%');
        track.setAttribute('aria-valuenow', String(Math.round(p * 100)));
      }

      if (btn) {
        btn.addEventListener('click', function () {
          if (audio.paused) {
            document.querySelectorAll('.sb-player__audio').forEach(function (o) { if (o !== audio) o.pause(); });
            audio.play().catch(function () { /* swallow autoplay rejections */ });
          } else {
            audio.pause();
          }
        });
      }

      audio.addEventListener('play', function () {
        root.setAttribute('data-playing', '');
        if (btn) btn.setAttribute('aria-label', 'Pause ' + title);
      });
      audio.addEventListener('pause', function () {
        root.removeAttribute('data-playing');
        if (btn) btn.setAttribute('aria-label', 'Play ' + title);
      });
      audio.addEventListener('ended', function () {
        root.removeAttribute('data-playing');
        paint(0);
        if (cur) cur.textContent = '0:00';
      });
      audio.addEventListener('loadedmetadata', function () {
        if (dur && isFinite(audio.duration)) dur.textContent = fmt(audio.duration);
      });
      audio.addEventListener('timeupdate', function () {
        var d = audio.duration || 0;
        paint(d > 0 ? audio.currentTime / d : 0);
        if (cur) cur.textContent = fmt(audio.currentTime);
      });

      function seekX(clientX) {
        var r = track.getBoundingClientRect();
        var f = clamp((clientX - r.left) / r.width, 0, 1);
        if (isFinite(audio.duration) && audio.duration > 0) {
          audio.currentTime = f * audio.duration;
          paint(f);
          if (cur) cur.textContent = fmt(audio.currentTime);
        }
      }
      var dragging = false;
      track.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        seekX(e.clientX);
      });
      track.addEventListener('pointermove', function (e) { if (dragging) seekX(e.clientX); });
      track.addEventListener('pointerup', function () { dragging = false; });
      track.addEventListener('pointercancel', function () { dragging = false; });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime + 5, 0, audio.duration);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime - 5, 0, audio.duration);
        } else if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          if (btn) btn.click();
        }
      });

      paint(0);
    }

    function initAll() {
      var nodes = document.querySelectorAll('.sb-player');
      for (var i = 0; i < nodes.length; i++) wire(nodes[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    window.sbPlayerInit = initAll;
  })();
  } catch(e) { console.error(e); }
})();

})();
